import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsShopping() {
  const descriptionList = [
    "Vous souhaitez acheter un ordinateur, un périphérique ou un composant, mais vous ne savez pas quel modèle choisir ?",
    "Grâce à notre expertise, nous vous aidons à trouver le meilleur rapport qualité/prix selon vos besoins (bureautique, gaming, montage vidéo, professionnel…).",
    "Vous évitez ainsi les mauvaises surprises et faites un achat adapté et optimisé pour votre utilisation.",
  ];
  const deroulementList = [
    "1 Prise de rendez-vous : Nous convenons d'un moment pour discuter de vos besoins et de votre budget.",
    "2 Analyse de votre utilisation : Définition du type de matériel idéal en fonction de votre usage (PC portable, PC fixe, composants, écran, imprimante…).",
    "3 Comparaison des options : Étude des modèles disponibles, des performances et du rapport qualité/prix sur le marché.",
    "5 Assistance à l'installation (optionnel) : Aide à la mise en service et aux premiers réglages si nécessaire (supplément et sur un autre rendez-vous).",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="CONSEIL À L'ACHAT DE MATÉRIEL INFORMATIQUE"
        price="20€ TTC"
        atelier={true}
        domicile={true}
        time="30min - 1h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Ce service peut être fait en atelier ou par téléphone." />
    </div>
  );
}

export default TarifsShopping;
